<template>
  <div class="border-0 w-full flex gap-2 items-center">
    <input
      v-model="model"
      class="disabled:bg-gray-2 disabled:text-darkGray-2 disabled:cursor-not-allowed"
      type="checkbox"
      @input="customChange"
      :id="keyId"
      :disabled="props.disabled ? true : null"
    />
    <label class="text-darkGray-1" :for="keyId">
      {{ placeholder }}
    </label>
  </div>
</template>
<script setup lang="ts">
import { defineProps, ref } from "vue";
import { defineEmits } from "@vue/runtime-core";
import { useStore } from "vuex";
const emit = defineEmits(["change"]);
const store = useStore();
const props = defineProps<{
  model: boolean;
  keyId: string;
  placeholder: string;
  disabled: boolean;
}>();
let model = ref(props.model);

function customChange(event: any) {
  const x = {
    value: !model.value,
    key: props.keyId,
  };
  emit("change", x);
}
</script>
<style></style>
